import { messageBus } from 'crm-message-bus/MessageBus';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { useCallback } from 'react';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { useObjectTypeId } from '../hooks/useObjectTypeId';
import { useProperty } from '../hooks/useProperty';
import UILink from 'UIComponents/link/UILink';
import { useGetHasScope } from '../hooks/useGetHasScope';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormattedFrameworkScore = ({
  objectId,
  propertyValue,
  frameworkScoreConfig,
  dataAttributes,
  placeholder
}) => {
  useComponentMountMetric('FormattedFrameworkScore');
  const getHasScope = useGetHasScope();
  const hasServiceHubSeat = getHasScope('customer-success-workspace-access');
  const hasMarketingHubSeat = getHasScope('mh-lead-scoring-view');
  const hasSeat = hasServiceHubSeat || hasMarketingHubSeat;
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const handleOnClick = useCallback(() => {
    messageBus.publish(TOPIC_NAMES.OPEN_SCORE_HISTORY, {
      envelope: {
        sourceId: 'customer-data-properties'
      },
      data: {
        objectTypeId,
        objectId: Number(objectId),
        outputProperty: property.name,
        appType: frameworkScoreConfig.appType
      }
    });
  }, [objectTypeId, objectId, property, frameworkScoreConfig]);
  const displayValue = getDisplayedValue(property, propertyValue, undefined, undefined, objectTypeId) || placeholder;
  return objectId && propertyValue != null && propertyValue !== '' && hasSeat ? /*#__PURE__*/_jsx(UILink, Object.assign({
    onClick: handleOnClick
  }, dataAttributes, {
    children: displayValue
  })) : /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
    children: displayValue
  }));
};